import React, { useState } from 'react';
import {TextField} from '@mui/material/';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import {useStyles} from './style';

export default function FormControlDeEntrada(props) {
    const classes = useStyles(props);
    const [self] = useState(props.this);
    const isCuiField = (props?.name || "").toLowerCase().includes("cui");
    const isPhoneField = (props?.name || "").toLowerCase().includes("telefono");

    return (
        <>
            {props.showInputFormControl && (
                <FormControl className={classes.formControl} >
                    <TextField
                        key={props.name}
                        label={props.label}
                        // variant="standard"
                        id={props.name}
                        name={props.name}
                        value={props.value}
                        autoFocus={props.autofocus}
                        multiline={props.multiline}
                        onChange={(event)=>{
                            let value = event?.target?.value ?? "";

                            if(isCuiField) {
                                value = value.toString().replace(/\D/g, "").slice(0, 13);
                                event.target.value = value;
                            } else if(isPhoneField) {
                                value = value.toString().replace(/\D/g, "").slice(0, 8);
                                event.target.value = value;
                            } else if(props.maxLength && value?.length > props.maxLength) {
                                return;
                            }

                            props.handleChange(event,self)
                            if(props?.manejadorDeCambio) props.manejadorDeCambio(event,self)
                        }}
                        onKeyPress={props.keyPress}
                        disabled={props.disabled}
                        error={props.isError}
                        aria-describedby="component-error-text"
                        inputProps={isCuiField ? { maxLength: 13, inputMode: 'numeric' } : isPhoneField ? { maxLength: 8, inputMode: 'numeric' } : undefined}
                    />
                    {(props.isError) ? <FormHelperText className="Mui-error" id="component-error-text">{props.errorMessages}</FormHelperText> : null }
                </FormControl>
            )}
        </>
    )
}

FormControlDeEntrada.defaultProps = {
    multiline : false,
    maxLength: null,
    showInputFormControl: true
}